module.exports = __webpack_public_path__ + "img/oauth2.a6e99b3b.svg";